import React from "react";
import { useLang } from "../i18n/LanguageContext";
import BookingForm from "../components/BookingForm";
import SEO from "../components/SEO";

const Book = () => {
  const { t } = useLang();
  return (
    <>
      <SEO
        title={t.seo.book.title}
        description={t.seo.book.description}
        keywords={t.seo.book.keywords}
        path="/book"
      />

      <section className="relative pt-32 pb-10 md:pt-40 md:pb-14 bg-cream overflow-hidden">
        <div className="absolute top-10 right-10 w-32 h-32 checkered-fine opacity-20" />
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 anim-fade-up relative">
          <div className="bt-tag mb-5">Brothers Taxi</div>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-black uppercase tracking-tighter text-zinc-900 max-w-4xl">
            <span className="font-serif italic font-normal text-zinc-600 normal-case block mb-2">{t.accents.soSimple}</span>
            {t.booking.title}
          </h1>
          <p className="mt-6 text-zinc-600 text-xl max-w-3xl">{t.booking.subtitle}</p>
        </div>
      </section>

      <section className="bg-mist py-16 md:py-20">
        <div className="max-w-[1000px] mx-auto px-6 md:px-12">
          <div className="bg-white border border-zinc-200 rounded-3xl overflow-hidden shadow-taxi-lift">
            <div className="bg-zinc-900 px-6 py-5">
              <div className="text-xs uppercase tracking-[0.2em] font-extrabold text-[#FFD500]">{t.booking.title}</div>
              <div className="text-zinc-300 text-sm mt-1">{t.booking.subtitle}</div>
            </div>
            <BookingForm />
          </div>
        </div>
      </section>
    </>
  );
};

export default Book;
